import { useLocalStorageState } from '@hcs/local-storage-state';
import { EngagementTrackingDevToolState } from '@hcs/types';

interface EngagementTrackingDevToolLocalStorageState {
  logEvents: 'all' | 'meaningful' | false;
  outlineSections: true | false;
}

export const useEngagementTrackingDevToolState = () => {
  const { state: localStorageState, actions } =
    useLocalStorageState<EngagementTrackingDevToolLocalStorageState>(
      'engagementTrackingDevTool',
    );
  const state: EngagementTrackingDevToolState = {
    logEvents:
      localStorageState?.logEvents === null ||
      localStorageState?.logEvents === undefined ||
      localStorageState?.logEvents === false
        ? false
        : localStorageState?.logEvents === 'all'
          ? 'all'
          : 'meaningful',
    outlineSections: localStorageState?.outlineSections === true,
  };
  return {
    state,
    actions: {
      setOutlineSections: (value: boolean) => {
        actions.setKeyValue('outlineSections', value);
      },
      setLogEvents: (value: 'all' | 'meaningful' | false) => {
        actions.setKeyValue('logEvents', value);
      },
    },
  };
};
